/**
 * UNION Booking Journey Configuration
 *
 * Defines the standard booking flow: addons → association-info → summary → complete
 * Uses the timeslot's availability type defaults (BOOKING or REQUEST) for all zone configurations.
 */

import { CheckoutJourney } from '../models/checkout-journey.types';
import { BookingTypeName } from '@shared/models/enums';
import { inject } from '@angular/core';
import { CheckoutStore } from '../checkout.store';

export const UNION_JOURNEY: CheckoutJourney = {
  type: BookingTypeName.UNION,
  searchRoute: 'associations/search/union', // Base search route for "return to search" functionality
  page: [
    {
      pageRoute: 'addons',
      label: 'Tilvalg',
      ariaLabel: 'Tilvalg',
    },
    {
      pageRoute: 'association-info',
      label: 'Foreningsinfo',
      ariaLabel: 'Foreningsinfo',
    },
    {
      pageRoute: 'summary',
      label: 'Oversigt',
      ariaLabel: 'Oversigt',
      canActivate: () => {
        const store = inject(CheckoutStore);
        return !!store.bookingId();
      },
    },
    {
      pageRoute: 'complete',
      label: 'Booking gennemført',
      ariaLabel: 'Booking gennemført',
    },
  ],
};
